export class ExcusableCreateModel {
  public RequestOrderId?: number;
  public ShippingType?: number;
  public Type?: number;
  public Status?: number;
  public Description?: string;
  public AgreementRef?: string;
  public RequestOrderType?: number;
  public Files?: any[];
}
